import { WebSocketService } from '@api/WebsocketClient'

// TODO: try catch
export async function sendWSMessageListener (input: any) {
    const websocketClient = WebSocketService.getInstance()
    if (!websocketClient || !websocketClient.isConnected()) {
        console.error('ATBase: websocket not connected during sendMessage request')
    }
    await websocketClient.sendMessage(input?.data?.storeId, input?.data?.currentTool, input?.data?.messageId, input?.data?.userQuery)
    return Promise.resolve()
}
